// Layer constants — Detection Engine System 1 (spec §1).
//
// Семь L-слоёв шага 6 визарда. Canonical key = короткое имя (как в prior-art
// remark_s201.py / sweep_sectionF.py — меньше translation-риска). L#-коды и
// аббревиатуры gating-таблиц (§3.3) даны отдельными картами.

/** Canonical layer order L1..L7 (spec §1). */
export const LAYERS = [
  'Vitality', // L1 — daily energy
  'Security', // L2 — ground holds
  'Growth', // L3 — complexity handled with ease
  'Authorship', // L4 — own your choices
  'Wanting', // L5 — live pull toward something specific
  'Yourself', // L6 — being yourself / internal standard
  'Lasting', // L7 — wanted the experience to last
];

/** L1..L7 wizard code → canonical name. */
export const CODE_TO_LAYER = {
  L1: 'Vitality',
  L2: 'Security',
  L3: 'Growth',
  L4: 'Authorship',
  L5: 'Wanting',
  L6: 'Yourself',
  L7: 'Lasting',
};

/** Canonical name → L1..L7 code. */
export const LAYER_TO_CODE = Object.fromEntries(
  Object.entries(CODE_TO_LAYER).map(([code, name]) => [name, code]),
);

/** Gating-table abbreviation (§3.3) → canonical name. */
export const ABBR_TO_LAYER = {
  V: 'Vitality',
  Se: 'Security',
  G: 'Growth',
  A: 'Authorship',
  W: 'Wanting',
  Y: 'Yourself',
  L: 'Lasting',
};

/** Canonical name → gating abbreviation. */
export const LAYER_TO_ABBR = Object.fromEntries(
  Object.entries(ABBR_TO_LAYER).map(([abbr, name]) => [name, abbr]),
);

/** Index of a layer in the fixed L1..L7 order (for deterministic tie-breaks). */
export function layerIndex(name) {
  return LAYERS.indexOf(name);
}

/** Human display name for §IV eyebrow / copy slots. */
export const DISPLAY_NAME = {
  Vitality: 'Vitality',
  Security: 'Security',
  Growth: 'Growth',
  Authorship: 'Authorship',
  Wanting: 'Wanting',
  Yourself: 'Being yourself',
  Lasting: 'Wanted to last',
};
